const authDataKey = 'mobile_counter_auth_data';

function loggedIn() {
    const authData = localStorage.getItem(authDataKey);

    if (authData) {
        const data = JSON.parse(authData);

        return data.token !== null;
    }

    return false;
}

function setData(data) {
    localStorage.setItem(authDataKey, JSON.stringify(data));
}

function getUserData() {
    const authData = localStorage.getItem(authDataKey);

    if (authData) {
        const data = JSON.parse(authData);

        return data.member;
    }

    return null;
}

function getToken() {
    const authData = localStorage.getItem(authDataKey);

    if (authData) {
        const data = JSON.parse(authData);

        return data.token;
    }

    return null;
}

function clearData() {
    localStorage.removeItem(authDataKey);
}

export default {
    loggedIn,
    setData,
    getUserData,
    getToken,
    clearData,
};